
































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
@Component({
    name: 'PathAlsTabItem',
})
export default class PathAlsTabItem extends Vue {
    @Injectable() public container!: Container;

    @Prop() public pathanalysislist: any;
    @Prop() public tabList: any;
    @Prop() public tabIndex: any;
    @Prop() public toTabItemClick: any;
    @Prop() public resultLength: any;
    @Prop() public toSinglePathNode: any;
    @Prop() public isShowPathAlsTabBusItem: any;

    private  pathAlslistDatas: any[] = [];
    private  iconObj: any = {
        右转: 'right',
        左转: 'left',
        直行: 'straight',
    };
    constructor() {
        super();
    }


    @Watch('pathanalysislist', {deep: true})
    public onChange(val: any) {
        this.pathAlslistDatas = [];
        if (val.length) {
            val.map((item: any) => {
                const temp = this.iconObj[item.direct] ? this.iconObj[item.direct] : 'straight';
                item.iconClass = temp;
                this.pathAlslistDatas.push(item);
            });
        }
    }

}
